var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 13.63,
    width: 50.65,
    height: 44.95,
    rx: 7.67,
    style: {
      fill: "#fff",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 17.89a1.73 1.73 0 0 0-2.79 1.22l-.34 4.11s0 2.18-1.54 2.31-13.68.12-22.15 8.31a36.66 36.66 0 0 0-6.89 10c-.33.69-.64 1.38-.94 2.07a4.3 4.3 0 0 0 6.1 5.41c4.52-2.6 8.89-5.24 13.1-6.13A34 34 0 0 1 44 44.52s2.06.55 2.07 1.72c0 1 0 2.7.14 4.18A1.78 1.78 0 0 0 49 51.7c4.76-3.63 14.81-11.35 18.62-14.83a3 3 0 0 0-.08-4.44Z",
    style: {
      fill: "#fff",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: 3
    },
    className: "cls-1"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartage);
export default __webpack_public_path__ + "static/media/PARTAGE.082a0ff6.svg";
export { ForwardRef as ReactComponent };